module.exports = __webpack_public_path__ + "static/media/blog4.aebe24b5.jpg";